// Labels and limits of the Rule tab. They mirror reminder_designer/rule/controller.js and rule_step/controller.js.

export const CODE_RE = /^[A-Z][A-Z0-9_]{1,49}$/;
export const TIME_RE = /^([01]\d|2[0-3]):[0-5]\d$/;
export const MAX_STEPS = 10;
export const MAX_CHANNELS = 5;
export const MAX_ENTRIES = 10;
export const MAX_TAGS = 20;
export const MAX_OFFSETS = 10;

export const FREQ_LABEL = { DAILY: "Daily", WEEKLY: "Weekly", HOURLY: "Hourly", MONTHLY: "Monthly", YEARLY: "Yearly", CRON: "Cron" };
export const OFFSET_UNIT_LABEL = { DAY: "Days", HOUR: "Hours", MINUTE: "Minutes" };
export const REPEAT_UNIT_LABEL = { MINUTE: "Minutes", HOUR: "Hours", DAY: "Days", WORKING_DAY: "Working days" };
export const WAIT_UNIT_LABEL = { MINUTE: "Minutes", HOUR: "Hours", DAY: "Days", WORKING_DAY: "Working days", REMINDER_COUNT: "Reminders sent" };
export const ON_SKIP_LABEL = { NEXT_WORKING_DAY: "Send on the next working day", DROP: "Skip that send" };
export const ROLE_LABEL = { SUPER_ADMIN: "Super Admin", ADMIN: "Admin", CLIENT: "Client", EMPLOYEE: "Employee" };

export const TIMEZONE_BASES = [
  { value: "RULE", label: "The rule's timezone", hint: "Every case runs on the same clock." },
  { value: "SUBJECT", label: "Each user's timezone", hint: "From the user's Settings; needs a source about a user." },
];

export const REPEAT_MODES = [
  { value: "ONCE", label: "Once per step", hint: "Each step sends one time." },
  { value: "EVERY", label: "Repeat", hint: "A step sends again until the case closes or the limit is reached." },
];

export const DAYS_OF_WEEK = [
  { value: 1, label: "Mon" },
  { value: 2, label: "Tue" },
  { value: 3, label: "Wed" },
  { value: 4, label: "Thu" },
  { value: 5, label: "Fri" },
  { value: 6, label: "Sat" },
  { value: 7, label: "Sun" },
];

export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((label, index) => ({ value: String(index + 1), label }));
export const DAY_OF_MONTH_OPTIONS = [...Array.from({ length: 31 }, (_v, i) => ({ value: String(i + 1), label: String(i + 1) })), { value: "-1", label: "Last day" }];
export const QUICK_OFFSETS = [-7, -3, -1, 0, 1];

// The editor's tabs, and the error keys (prefixes) each one owns.
export const RULE_TABS = [
  { key: "basics", label: "Basics", errorKeys: ["code", "name", "trigger_fid", "priority", "description", "params"] },
  { key: "when", label: "When", errorKeys: ["schedule", "timezone", "offsets", "valid_to"] },
  { key: "who", label: "Who", errorKeys: ["audience"] },
  { key: "policies", label: "Policies", errorKeys: ["calendar", "repeat", "stop"] },
  { key: "ladder", label: "Ladder", errorKeys: ["steps"] },
];
